/* eslint-disable */
import { PluginContainerData, Link } from './common';

import { LinkPreviewData_Styles_Position } from './plugin_link_preview.enums';

export interface LinkPreviewData {
  /** Styling for the link preview's container. */
  containerData?: PluginContainerData;
  /** Link details. */
  link?: Link;
  /** Preview title. */
  title?: string;
  /** Preview thumbnail URL. */
  thumbnailUrl?: string;
  /** Preview description. */
  description?: string;
  /** The preview content as HTML. */
  html?: string;
  /** Styling for the link preview. */
  styles?: LinkPreviewData_Styles;
}

export interface LinkPreviewData_Styles {
  /** Background color as a hexadecimal value. */
  backgroundColor?: string;
  /** Title color as a hexadecimal value. */
  titleColor?: string;
  /** Subtitle color as a hexadecimal value. */
  subtitleColor?: string;
  /** Link color as a hexadecimal value. */
  linkColor?: string;
  /** Border width in pixels. */
  borderWidth?: number;
  /** Border radius in pixels. */
  borderRadius?: number;
  /** Border color as a hexadecimal value. */
  borderColor?: string;
  /** Position of thumbnail. Defaults to `START`. */
  thumbnailPosition: LinkPreviewData_Styles_Position;
}

export function linkPreviewData_Styles_PositionFromJSON(
  object: any
): LinkPreviewData_Styles_Position {
  switch (object) {
    case 0:
    case 'START':
      return LinkPreviewData_Styles_Position.START;
    case 1:
    case 'END':
      return LinkPreviewData_Styles_Position.END;
    case 2:
    case 'TOP':
      return LinkPreviewData_Styles_Position.TOP;
    case 3:
    case 'HIDDEN':
      return LinkPreviewData_Styles_Position.HIDDEN;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return LinkPreviewData_Styles_Position.UNRECOGNIZED;
  }
}

export function linkPreviewData_Styles_PositionToJSON(
  object: LinkPreviewData_Styles_Position
): string {
  switch (object) {
    case LinkPreviewData_Styles_Position.START:
      return 'START';
    case LinkPreviewData_Styles_Position.END:
      return 'END';
    case LinkPreviewData_Styles_Position.TOP:
      return 'TOP';
    case LinkPreviewData_Styles_Position.HIDDEN:
      return 'HIDDEN';
    default:
      return 'UNKNOWN';
  }
}

const baseLinkPreviewData: object = {};

export const LinkPreviewData = {
  fromJSON(object: any): LinkPreviewData {
    const message = { ...baseLinkPreviewData } as LinkPreviewData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.link =
      object.link !== undefined && object.link !== null ? Link.fromJSON(object.link) : undefined;
    message.title =
      object.title !== undefined && object.title !== null ? String(object.title) : undefined;
    message.thumbnailUrl =
      object.thumbnailUrl !== undefined && object.thumbnailUrl !== null
        ? String(object.thumbnailUrl)
        : undefined;
    message.description =
      object.description !== undefined && object.description !== null
        ? String(object.description)
        : undefined;
    message.html =
      object.html !== undefined && object.html !== null ? String(object.html) : undefined;
    message.styles =
      object.styles !== undefined && object.styles !== null
        ? LinkPreviewData_Styles.fromJSON(object.styles)
        : undefined;
    return message;
  },

  toJSON(message: LinkPreviewData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.link !== undefined && (obj.link = message.link ? Link.toJSON(message.link) : undefined);
    message.title !== undefined && (obj.title = message.title);
    message.thumbnailUrl !== undefined && (obj.thumbnailUrl = message.thumbnailUrl);
    message.description !== undefined && (obj.description = message.description);
    message.html !== undefined && (obj.html = message.html);
    message.styles !== undefined &&
      (obj.styles = message.styles ? LinkPreviewData_Styles.toJSON(message.styles) : undefined);
    return obj;
  },
};

const baseLinkPreviewData_Styles: object = {
  thumbnailPosition: LinkPreviewData_Styles_Position.START,
};

export const LinkPreviewData_Styles = {
  fromJSON(object: any): LinkPreviewData_Styles {
    const message = { ...baseLinkPreviewData_Styles } as LinkPreviewData_Styles;
    message.backgroundColor =
      object.backgroundColor !== undefined && object.backgroundColor !== null
        ? String(object.backgroundColor)
        : undefined;
    message.titleColor =
      object.titleColor !== undefined && object.titleColor !== null
        ? String(object.titleColor)
        : undefined;
    message.subtitleColor =
      object.subtitleColor !== undefined && object.subtitleColor !== null
        ? String(object.subtitleColor)
        : undefined;
    message.linkColor =
      object.linkColor !== undefined && object.linkColor !== null
        ? String(object.linkColor)
        : undefined;
    message.borderWidth =
      object.borderWidth !== undefined && object.borderWidth !== null
        ? Number(object.borderWidth)
        : undefined;
    message.borderRadius =
      object.borderRadius !== undefined && object.borderRadius !== null
        ? Number(object.borderRadius)
        : undefined;
    message.borderColor =
      object.borderColor !== undefined && object.borderColor !== null
        ? String(object.borderColor)
        : undefined;
    message.thumbnailPosition =
      object.thumbnailPosition !== undefined && object.thumbnailPosition !== null
        ? linkPreviewData_Styles_PositionFromJSON(object.thumbnailPosition)
        : LinkPreviewData_Styles_Position.START;
    return message;
  },

  toJSON(message: LinkPreviewData_Styles): unknown {
    const obj: any = {};
    message.backgroundColor !== undefined && (obj.backgroundColor = message.backgroundColor);
    message.titleColor !== undefined && (obj.titleColor = message.titleColor);
    message.subtitleColor !== undefined && (obj.subtitleColor = message.subtitleColor);
    message.linkColor !== undefined && (obj.linkColor = message.linkColor);
    message.borderWidth !== undefined && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== undefined && (obj.borderRadius = message.borderRadius);
    message.borderColor !== undefined && (obj.borderColor = message.borderColor);
    message.thumbnailPosition !== undefined &&
      (obj.thumbnailPosition = linkPreviewData_Styles_PositionToJSON(message.thumbnailPosition));
    return obj;
  },
};
